// @flow
import * as React from "react";
import {reisy, use} from "reisy";
import Cover from "../components/cover.js";
import type {Publishable} from "../api/types.js";
import {skipToNative} from "../components/link.js";

const DEFAULT_SIZE = 400;

const styles = reisy`
@namespace EmbedWidget;
Container {
	/* this is in order to avoid scrollbars on the widget iframe */
	position: absolute;
	width: 100%;
	height: 100%;
	overflow: hidden;
}`;

type Props = {
	content: Publishable;
};

class EmbedWidget extends React.Component {
	props: Props;
	elem: HTMLElement;

	setElem = (elem: HTMLElement) => (this.elem = elem);

	handleClick = (ev: MouseEvent) => {
		if (skipToNative(ev)) { return; }
		// flow: shush!
		const url: string = (ev.currentTarget: any).href;
		ev.preventDefault();
		ev.stopPropagation();
		window.parent.postMessage({
			type: "kent-open",
			url,
		}, "*");
	};

	handleResize = () => {
		const {elem} = this;
		const scale = Math.min(window.innerWidth, window.innerHeight) / DEFAULT_SIZE;
		// XXX: explicit cast because we know .firstChild is valid!
		const {style} = (elem.firstChild: any);
		const origin = "0 0";
		const transform = `scale(${scale})`;
		style.transformOrigin = origin;
		style.webkitTransformOrigin = origin;
		style.transform = transform;
		style.webkitTransform = transform;
	};

	componentDidMount() {
		if (!IS_BROWSER) { return; }
		window.addEventListener("resize", this.handleResize);
		this.handleResize();
	}
	componentWillUnmount() {
		window.removeEventListener("resize", this.handleResize);
	}

	render() {
		return (
			<div ref={this.setElem} {...use(styles.Container)}>
				<Cover
					useShareImage
					content={this.props.content} to={{query: {}}}
					onClick={this.handleClick} />
			</div>
		);
	}
}

export default EmbedWidget;



// WEBPACK FOOTER //
// ./lib/screens/embedwidget.js